import { apiService } from "./api.service";
import { IResponseModel } from "@/models/interfaces/response.model.interface";
import { IMultivariateConfiguration } from "@/models/interfaces/multivariate/multivariate-configuration.model.interface";

class MultivariateService {

    private static serviceInstance: MultivariateService;

    private constructor() { }

    public static get instance() {
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async getConfiguration()
  : Promise<IResponseModel<IMultivariateConfiguration>> {
    return apiService.get(`/api/v1/multivariate/configuration`)
      .then((response) => {
            const result = response.data as IResponseModel<IMultivariateConfiguration>;
            return result;
        })
      .catch((error) => {
            const result: IResponseModel<IMultivariateConfiguration> = {
                success: false,
                result: null
            };
            return result;
        });
  }
}

export const multivariateService = MultivariateService.instance;
